import React from "react";
import { AccordionDetails, Divider, Typography } from "@mui/material";
import QuestionType from "../Question/QuestionType";
import { useLanguageContext } from "../../../Context/LanguageContext";

export default function SummaryAccordionDetails({
  keyForList,
  handleCreateTicketCheckboxChange,
  showCanCreateTicketCheckbox,
}) {
  const { localization } = useLanguageContext();
  return (
    <AccordionDetails>
      <div className="w-100">
        {Object.keys(keyForList).map((chapterId, indexChapter) => {
          const chapter = keyForList[chapterId];
          return (
            <div key={chapterId}>
              <Typography variant="h6">
                {localization.chapter + ": " + chapter.title}
              </Typography>
              {Object.values(chapter.blockList).map((block) => (
                <div key={block.id}>
                  <Typography variant="h6">
                    {localization.checkListblock + ": " + block.title}
                  </Typography>
                  {block.pruefFragenItemModels.map((item, index) => (
                    <QuestionType
                      title="Questionnaire"
                      question={item}
                      questionNo={index + 1}
                      key={item.id}
                      blockId={block.id}
                      onFieldChange={() => {}}
                      handleBlurChanges={() => {}}
                      isDisable={true}
                      handleCreateTicketCheckbox={
                        handleCreateTicketCheckboxChange
                      }
                      showCanCreateTicketCheckbox={showCanCreateTicketCheckbox}
                    />
                  ))}

                  <Divider className="summaryDivider" />
                </div>
              ))}
              {indexChapter < Object.keys(keyForList).length - 1 && (
                <Divider className="summaryDivider" />
              )}
            </div>
          );
        })}
      </div>
    </AccordionDetails>
  );
}
